<template>
  <div class="dropdown-v2">
    <div class="dropdown-v2__input" @click="open = !open">
      <span>{{ getLabel(value) }} </span>
      <ChevronUpIcon v-if="open" />
      <ChevronDownIcon v-else />
    </div>
    <div v-if="open" v-click-outside="close" class="dropdown-v2__container">
      <svg
        class="dropdown-v2__arrow"
        xmlns="http://www.w3.org/2000/svg"
        width="48"
        height="8"
        viewBox="0 0 48 8"
        fill="none"
      >
        <g filter="url(#filter0_d_5687_116)">
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M32 8L16 8L22.5858 1.41421C23.3668 0.633163 24.6332 0.633164 25.4142 1.41421L32 8Z"
            fill="#333333"
          />
        </g>
        <defs>
          <filter
            id="filter0_d_5687_116"
            x="0"
            y="-7.17139"
            width="48"
            height="39.1714"
            filterUnits="userSpaceOnUse"
            color-interpolation-filters="sRGB"
          >
            <feFlood flood-opacity="0" result="BackgroundImageFix" />
            <feColorMatrix
              in="SourceAlpha"
              type="matrix"
              values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
              result="hardAlpha"
            />
            <feOffset dy="8" />
            <feGaussianBlur stdDeviation="8" />
            <feColorMatrix
              type="matrix"
              values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.17 0"
            />
            <feBlend
              mode="normal"
              in2="BackgroundImageFix"
              result="effect1_dropShadow_5687_116"
            />
            <feBlend
              mode="normal"
              in="SourceGraphic"
              in2="effect1_dropShadow_5687_116"
              result="shape"
            />
          </filter>
        </defs>
      </svg>
      <div class="dropdown-v2__rounded-tile dropdown-v2__bg">
        <div class="dropdown-v2__wrapper dropdown-v2__glass">
          <div class="dropdown-v2__header">
            <span class="dropdown-v2__title">
              {{ title }}
            </span>
            <XIcon class="dropdown-v2__close-icon" @click="close" />
          </div>
          <ul
            ref="dropdownListItems"
            class="dropdown-v2__list"
            :class="{ 'dropdown-v2__list--scroll': scrollPadding }"
          >
            <li
              v-for="(option, index) in options"
              :key="index"
              class="dropdown-v2__list-item"
              :class="{ 'dropdown-v2__list-item--selected': option === value }"
              @click="selectOption(option)"
            >
              <span
                v-if="option[iconKey]"
                class="dropdown-v2__list-item-icon"
                name="listItemIcon"
              >
                {{ option[iconKey] }}
              </span>
              <span class="dropdown-v2__list-item-label">
                {{ getLabel(option) }}
              </span>
              <span class="dropdown-v2__list-item-selection">
                <svg
                  v-if="option === value"
                  xmlns="http://www.w3.org/2000/svg"
                  width="20"
                  height="20"
                  viewBox="0 0 20 20"
                  fill="none"
                >
                  <rect
                    x="0.5"
                    y="0.5"
                    width="19"
                    height="19"
                    rx="9.5"
                    fill="#00DA99"
                    fill-opacity="0.1"
                    stroke="#70FFD4"
                  />
                  <circle cx="10" cy="10" r="5" fill="white" />
                </svg>
                <svg
                  v-else
                  xmlns="http://www.w3.org/2000/svg"
                  width="20"
                  height="20"
                  viewBox="0 0 20 20"
                  fill="none"
                >
                  <rect
                    x="0.5"
                    y="0.5"
                    width="19"
                    height="19"
                    rx="9.5"
                    stroke="#AFB0BF"
                  />
                </svg>
              </span>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { XIcon, ChevronDownIcon, ChevronUpIcon } from 'vue-feather-icons'

export default {
  name: 'DropdownV2',
  components: {
    XIcon,
    ChevronDownIcon,
    ChevronUpIcon,
  },
  props: {
    value: {
      type: [String, Object],
      required: true,
    },
    title: {
      type: String,
      required: true,
    },
    labelKey: {
      type: String,
      required: false,
    },
    iconKey: {
      type: String,
      required: false,
    },
    options: {
      type: Array,
      default: () => [],
    },
    scrollPadding: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      open: false,
    }
  },
  methods: {
    selectOption(option) {
      this.$emit('input', option)
      this.close()
    },
    getLabel(value) {
      return typeof value === 'object' ? value[this.labelKey] : value
    },
    close() {
      this.open = false
    },
  },
}
</script>

<style lang="scss" scoped>
.dropdown-v2 {
  position: relative;
  &__input {
    display: flex;
    align-items: center;
    gap: 2px;
    color: var(--white);
    cursor: pointer;
  }
  &__container {
    display: flex;
    flex-direction: column;
    align-items: center;
    position: absolute;
    right: 0;
    left: 0;
    z-index: 20;
  }
  &__bg {
    background: var(--darker-gray);
  }
  &__glass {
    background: var(--glass-mid-gray);
  }
  &__rounded-tile {
    border-radius: 10px;
    overflow: hidden;
  }

  &__wrapper {
    display: flex;
    flex-direction: column;
    gap: 20px;
    padding: 20px;
    min-width: 300px;
  }

  &__header {
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
  &__title {
    color: var(--white);

    font-size: 1.125rem;
    font-style: normal;
    font-weight: 500;
    line-height: 1.5rem;
  }
  &__close-icon {
    color: var(--white-70);
    cursor: pointer;
  }

  &__list {
    display: flex;
    flex-direction: column;
    gap: 5px;
    padding: 0 5px 0 0;
    margin: 0;
    flex: 1;
    max-height: 200px;
    overflow-y: auto;

    &--scroll {
      padding-right: 20px;
    }
    &-item {
      display: flex;
      align-items: center;
      gap: 5px;
      height: 26px;

      color: var(--light-blue-gray);
      font-size: 0.75rem;
      font-style: normal;
      font-weight: 500;
      line-height: 1rem;

      cursor: pointer;

      &--selected {
        color: var(--white);
      }

      &-icon {
        font-size: 1.3125rem;
        font-style: normal;
        font-weight: 500;
        line-height: 1.625rem; /* 123.81% */
      }

      &-label {
        flex: 1;
      }
    }
  }
}
</style>
